import { useEffect } from "react";
import "./Contact.css";
import { useRef } from "react";
import emailjs from "emailjs-com";
import Aos from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_n156j5f",
        "template_oljape6",
        form.current,
        "X6dmB12bechLUVqnt"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };

  return (
    <section id="contact" data-aos="fade-up">
      
      <h5>Get In Touch</h5>
      <h2>
        Contact Me<span>🎊🎊</span>
      </h2>

      <div className="container contact__container">

        <form autoComplete="off" ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />

          <input type="email" name="email" placeholder="Your Email" required />

          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>

          <button type="submit" className="btn btn-primary">
            Send Message<span className="envelope">✉️</span>
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
